import { CAL_SEGMENT_SCENE_MNG } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: CAL_SEGMENT_SCENE_MNG,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  // relationSearch: true,
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入细分场景名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['segmentName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'segmentSceneCreate'
      }
    ]
  },

  view: {
    columns: [
      {
        props: {
          label: '细分场景名称',
          prop: 'segmentName',
          sortField: 'segmentName',
          width: 350
        }
      },
      {
        props: {
          label: '细分场景特征',
          prop: 'description',
          sortField: 'description'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 350
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '1'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'segmentSceneEdit',
        name: 'edit'
      }
    ]
  }
}
